import { apiConfigSlice } from "./ApiConfig.redux";

export const {
    resetApiConfig,
    updateApiComplete
  
} = apiConfigSlice.actions